import React, { useContext, useRef, useEffect, useState } from 'react';
import ListaResumenContext from '../../contexts/ListaResumenContext';
import RefsContext from '../../contexts/RefsContext';

import Feature from "@arcgis/core/widgets/Feature";
import { ActionListaResumenCercaRemoveAllResaltados, ActionListaResumenCercaResaltarElemento, ElementoListaResumenCapa } from '../../classes/reducerClasses';
import { TiposListaResumen } from '../../utils/enums';
import { ActionListaResumenCercaCambiarVisibilidadGrupo } from '../../classes/reducerClasses';
import { addGraphicListaResumen } from '../../utils/mapaUtils';
import { clickContainerExpandIfMovilVerticalAndPopupVisible } from '../../utils/widgetsUtils';

function ElementoListaResumen({ conAgrupacion, elementoListaResumen, indexElemento, zoomParaPunto, tipoListaResumen, seleccionarElementosGrupo, irToElementosGrupo }) {
    const { mapViewRef, expandsWidgetsButtonsRef } = useContext(RefsContext);
    const { dispatchListaResumenCerca } = useContext(ListaResumenContext);
    const featureWidgetRef = useRef(null);

    const [estadoFeature, setEstadoFeature] = useState(null);

    useEffect(() => {
        const feature = new Feature({
            container: featureWidgetRef.current,
            graphic: elementoListaResumen.graphic
        });
        feature.viewModel.watch("state", state => {
            setEstadoFeature(state);
        });
        return () => setEstadoFeature(null); //Importante!!
    }, [featureWidgetRef, elementoListaResumen.graphic])

    function zoomToElementoLista() {
        const { graphic } = elementoListaResumen;
        if (tipoListaResumen === TiposListaResumen.cerca) {
            clickContainerExpandIfMovilVerticalAndPopupVisible(mapViewRef.current, expandsWidgetsButtonsRef.current.expands.cerca);
            dispatchListaResumenCerca(new ActionListaResumenCercaRemoveAllResaltados());
        }
        mapViewRef.current.goTo(graphic.geometry).then(()=>{
          mapViewRef.current.graphics.removeAll();
            graphic.popupTemplate = graphic.layer.popupTemplate;
            mapViewRef.current.popup.open({ features: [graphic]});
            if (graphic.geometry.type === "point" && zoomParaPunto){
              mapViewRef.current.zoom = zoomParaPunto;
            }
        });     
    }
  
    function seleccionElementoLista (conAddGraphics = true) {
        //Debe limpiar todas las listas resumen que puedan haber
        // dispatchListasResumen(new ActionListasResumenRemoveAllResaltados());
        dispatchListaResumenCerca(new ActionListaResumenCercaRemoveAllResaltados());
        if (tipoListaResumen === TiposListaResumen.cerca){
            dispatchListaResumenCerca(new ActionListaResumenCercaResaltarElemento(indexElemento));
        }
        if (conAddGraphics){
            addGraphicListaResumen(mapViewRef.current, elementoListaResumen.graphic.geometry, tipoListaResumen);
        }
    }

    function ejecutarAccion(){
        if (elementoListaResumen.resaltado){
            zoomToElementoLista();
        } else {
            seleccionElementoLista();
        }
    }

    function mostrarOcultarGrupo(){
        if (tipoListaResumen === TiposListaResumen.cerca){
            dispatchListaResumenCerca(new ActionListaResumenCercaCambiarVisibilidadGrupo(!elementoListaResumen.desplegado, indexElemento));
        }
    }

    function verGrupo(){
        seleccionElementoLista(false)
        seleccionarElementosGrupo(elementoListaResumen);
    }

    function irToGrupo(){
        seleccionElementoLista(false)
        irToElementosGrupo(elementoListaResumen);
    }

    if (elementoListaResumen.tipo === ElementoListaResumenCapa.tipoAgrupacion){
        const titleArrow = elementoListaResumen.desplegado ? "Contraer" : "Expandir registros";
        const classArrow = "iconoLink fa fa-arrow-circle-" + (elementoListaResumen.desplegado ? "up" : "down");
        const numRegistros = elementoListaResumen.indexFin - elementoListaResumen.indexIni + 1;
        const sufijoPlural = numRegistros > 1 ? "s" : "";
        const clase = "elementoListaGrupo" + (elementoListaResumen.resaltado ? " elementoListaGrupoSeleccionado" : "");
        return (
            <tr className={clase}>
                <td style={{width: "97%"}} title={`${numRegistros} registro${sufijoPlural} asociado${sufijoPlural}`}>
                    {`${elementoListaResumen.valor} (${numRegistros})`}
                </td>
                <td title="Seleccionar elementos asociados" style={{ width: "1%", cursor: "pointer" }} onClick={verGrupo}>
                    <i className="iconoLink fa fa-map-marker" aria-hidden="true"></i>
                </td>
                <td title="Ir a elementos asociados" style={{ width: "1%", cursor: "pointer" }} onClick={irToGrupo}>
                    <i className="iconoLink fa fa-search-plus" aria-hidden="true"></i>
                </td>
                <td title={titleArrow} style={{ width: "1%", cursor: "pointer" }} onClick={mostrarOcultarGrupo}>
                    <i className={classArrow} aria-hidden="true"></i>
                </td>
            </tr>
        )
    } else {
        const style = { display: estadoFeature === "ready" && elementoListaResumen.visible ? "table-row" : "none" }; //Evita que haya un salto visual mostrando la lista con filas vacías y luego los widgets cargando y finalmente cargados
        const title = elementoListaResumen.resaltado ? "Navegar a" : "Seleccionar";
        const clase = elementoListaResumen.resaltado ? "elementoListaSeleccionado cursorZoomIn" : "elementoLista cursorPointer";
        return (
            <tr style={style} title={title} className={clase} onClick={ejecutarAccion}>
                <td colSpan={conAgrupacion ? 4 : 1}>
                    <div className='featureWidgetGeneral' ref={featureWidgetRef}></div>
                </td>
            </tr>
        )
    }
}

export default React.memo(ElementoListaResumen);